import { useEffect, useState } from 'react';

export const routes = [
  'opening',
  'menu',
  'play',
  'tutorial',
  'settings',
  'cast',
  'privacy',
  'terms',
] as const;
export type Route = (typeof routes)[number];

export interface Location {
  route: Route;
}

export function parseHash(hash: string): Location {
  const [head = ''] = hash.replace(/^#\/?/, '').split('/', 1);
  const route = (routes as readonly string[]).includes(head) ? (head as Route) : 'opening';
  return { route };
}

export function href(route: Route): string {
  return route === 'opening' ? '#/' : `#/${route}`;
}

export function navigate(route: Route): void {
  window.location.hash = href(route);
}

/** Minimal hash router. Unknown routes fall back to the opening screen. */
export function useHashRoute(): Location {
  const [location, setLocation] = useState<Location>(() => parseHash(window.location.hash));

  useEffect(() => {
    const controller = new AbortController();
    window.addEventListener(
      'hashchange',
      () => {
        setLocation(parseHash(window.location.hash));
        window.scrollTo(0, 0);
      },
      { signal: controller.signal },
    );
    return () => {
      controller.abort();
    };
  }, []);

  return location;
}
